'use client'

import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback } from '@/components/ErrorFallback'
import { logger } from '@/lib/services/logger.service'

interface GlobalErrorBoundaryProps {
  children: React.ReactNode
}

export function GlobalErrorBoundary({ children }: GlobalErrorBoundaryProps) {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, errorInfo) => {
        logger.error('Global error boundary caught unhandled error', error, {
          component: 'GlobalErrorBoundary',
          action: 'onError',
          errorInfo: {
            componentStack: errorInfo.componentStack
          },
          errorType: error?.name || 'unknown',
          errorMessage: error?.message
        })
      }}
      onReset={() => {
        // Optionally clear any error state
        window.location.reload()
      }}
    >
      {children}
    </ErrorBoundary>
  )
}